export default {
  back: 'Takaisin kampanjoihin',
  title: 'Kampanja',
  sent_at: 'Lähetetty {{time}}',
  breakdown_title: 'Toimitusyhteenveto',
  pending_receipts: {
    title: 'Toimitustilastot ovat tulossa',
    description:
      'Tämä kampanja lähetettiin juuri. Push-palveluntarjoajat vahvistavat toimituksen noin 15 minuutin kuluttua lähetyksestä, joten alla olevat luvut täydentyvät noin {{time}} — ei toimenpiteitä tarvita.',
    countdown:
      'Apple ja Google vahvistavat vastaanoton noin {{minutes}} min {{seconds}} s kuluttua (noin {{time}}). Tilastot päivittyvät automaattisesti.',
    ready: 'Vahvistusten pitäisi olla saapuneet. Alla olevat luvut päivittyvät nyt.',
    soon: 'pian',
  },
  recipients: {
    title: 'Vastaanottajat',
    subtitle: 'Kenelle kampanja lähetettiin ja saavuttiko se heidän laitteensa.',
    filters: {
      all: 'Kaikki',
      delivered: 'Toimitettu',
      pending: 'Odottaa vahvistusta',
      failed: 'Ei toimitettu',
    },
    columns: {
      recipient: 'Vastaanottaja',
      status: 'Tila',
      reason: 'Syy',
      clicked: 'Klikattu',
      sent_at: 'Lähetetty',
    },
    status: {
      delivered: 'Toimitettu',
      pending: 'Odottaa vahvistusta',
      failed: 'Ei toimitettu',
    },
    reasons: {
      DeviceNotRegistered: 'Sovellus poistettu tai ilmoitukset pois päältä (vanhentunut tunnus)',
      MessageRateExceeded: 'Expo rajoittaa tilapäisesti nopeutta',
      MessageTooBig: 'Ilmoituksen sisältö liian suuri',
      MismatchSenderId: 'Push-tunnistetiedot eivät täsmää',
      InvalidCredentials: 'Virheelliset push-tunnistetiedot',
      batch_failed: 'Erän lähetys epäonnistui',
      missing_ticket: 'Expo ei palauttanut vahvistusta',
      unknown: 'Tuntematon toimitusvirhe',
    },
  },
};
